// src/api/gradingApi.js
import api from './axios';

export const getGradingResults = (reservationId) =>
  api.get(`/grading/results/${reservationId}`);

export const submitGrading = (reservationId) =>
  api.post(`/grading/submit/${reservationId}`);

export const getLabGradingConfig = (labId) =>
  api.get(`/grading/config/lab/${labId}`);
